import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 1a1 1 0 0 0-2 0v1h-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2h-1V1a1 1 0 1 0-2 0v1h-5zm3.125 5a.625.625 0 1 0-1.25 0 .5.5 0 0 1-.5.5H5.5a.625.625 0 1 0 0 1.25h.375q.262 0 .5-.072v2.197H5.5a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25h-.875z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceCalendarDateOne = { render };
export {
  interfaceCalendarDateOne as default,
  render
};
//# sourceMappingURL=interface-calendar-date-one.svg.js.map
